export const MAX_TAG_LENGTH = 35;
export const MAX_TITLE_LENGTH = 80;
